import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { printParcelCreditNote } from '../../../../utils/printers/CreditNote';

const PrintCargoCreditNoteButton = ({parcel}) => {
  const handlePrintCreditNote = () => {
    printParcelCreditNote(parcel);
  };

  return (
      <Button
        color="light"
        className="border"
        onClick={handlePrintCreditNote}
      >
        <i className="fa fa-print" /> 
          {' '}Imprimir NC
      </Button>
    );
  }

PrintCargoCreditNoteButton.propTypes = {
  parcel: PropTypes.instanceOf(Map).isRequired,
};

export default PrintCargoCreditNoteButton;
